import React, { useEffect, useState } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Drawer,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Tag,
  Typography,
} from "antd";
import { ReactComponent as LeftArrowIcon } from "../../../../../assets/icons/chevron-left.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  useAddNewAddressMutation,
  useUpdateAddressMutation,
} from "../../../../../apis/Seller/SellerStoreSalesAPI";
import {
  // billingAddressSelector,
  createQuoteUserSelector,
  deliveryAddressSelector,
  editQuoteDataSelector,
} from "../../../../../redux/slices/createQuote/selector";
import {
  getBillingAddress,
  getDeliveryAddress,
  updateAddressFlag,
} from "../../../../../redux/slices/createQuote/action";
import {
  // showErrorToast,
  showSuccessToast,
} from "../../../../../NotificationToast/NotificationToast";
import { Option } from "antd/es/mentions";
import { gstRegex, stateOptions } from "../../../../../commonUtils/commonUtils";
import { useParams } from "react-router-dom";
import UserBillingConfirmModal from "../../UserBillingConfirmModal/UserBillingConfirmModal";
//import {isDisabledBillingAddress} from "../../../../commonFuntions/CommonUtilFunctions";
import { getCreateOrderUserData } from "../../../../../redux/slices/createOrder/action";
import "./AddressForm.css";

const GOOGLE_MAPS_LIBRARIES = ["places"];

const BillingAddress = ({
  billingModal,
  setBillingModal,
  setIsModalOpen,
  editData,
  initialFormData,
  billingFormData,
  setBillingFormData,
  addressListModal,
  showMobCreditIcon,
  mob_credit_check,
  addressList,
  addCustName,
  addCustMobileNo,
  addCustEmail,
  addCustGSTIN,
  handleSetSelector = () => {},
  getEditOrderAddressAPI,
  selectedMapAddress,
  setShowGoogleMapsModal,
  setPendingAddressType,
}) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCVLamNquALGHbWCgb-U3-Ab8OdSyhOkEM",
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  const [previewMap, setPreviewMap] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [editLocation, setEditLocation] = useState(null);
  const { Text, Title } = Typography;
  const params_id = useParams();
  // const billingAddressRedux = useSelector(billingAddressSelector);
  const deliveryAddressRedux = useSelector(deliveryAddressSelector);
  const mob_user = useSelector(createQuoteUserSelector);
  const mob_user_2 = useSelector(editQuoteDataSelector);
  const [
    createNewAddressApi,
    { isSuccess: createAddressSuccess, isLoading: isCreateLoading },
  ] = useAddNewAddressMutation();
  const [
    updateAddressApi,
    { isSuccess: updateAddressSuccess, isLoading: isUpdateLoading },
  ] = useUpdateAddressMutation();
  const dispatch = useDispatch();
  const [validationErrors, setValidationErrors] = useState({
    mobileNo: "",
    email: "",
    pincode: "",
    // Add more fields if needed
  });
  const [openBillingModal, setOpenBillingModal] = useState(false);
  const getIsMobileView = () =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false;
  const [isMobileView, setIsMobileView] = useState(getIsMobileView);
  // eslint-disable-next-line
  const [address_tag, setAddress_tag] = useState("");

  const handleCancelBillingModal = () => {
    setOpenBillingModal(false);
  };
  const handleSaveBillingModal = () => {
    setBillingFormData((prevData) => ({
      ...prevData,
      address_type: "",
    }));
    setOpenBillingModal(false);
  };
  const handleAddressTag = (event) => {
    // const checkedTag = event?.target?.checked;

    setBillingFormData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
    setAddress_tag(event.target.value);
  };
  const [isFormValid, setIsFormValid] = useState(false);
  const validateForm = () => {
    const requiredFields = [
      "nameCompany",
      "mobileNo",
      "addressI",
      // "email",
      "city",
      "state",
      "pincode",
    ];

    const isValid = requiredFields.every((field) => !!billingFormData[field]);
    setIsFormValid(isValid);
  };
  const handleCancel = () => {
    setBillingFormData(initialFormData);
    setBillingModal(false);
  };
  useEffect(() => {
    if (createAddressSuccess || updateAddressSuccess) {
      dispatch(updateAddressFlag(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAddressSuccess, updateAddressSuccess]);

  useEffect(() => {
    if (editData) {
      setBillingFormData({
        nameCompany: editData.name || "",
        mobileNo: editData.phone_number || "",
        gst: editData.gst_number || "",
        addressI: editData.address_line_1 || "",
        addressII: editData.address_line_2 || "",
        google_map_link: editData.address_line_2 || "",
        pincode: editData.pincode || "",
        city: editData.city || "",
        state: editData.state || "",
        email: editData.email || "",
        mob_credit: editData.mob_credit || "",
        address_tag: editData.address_tag || "Home",
        address_type: editData.address_type || "",
        site_person: editData?.site_person || "",
        site_person_mobile: editData?.site_person_mobile || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData]);

  const handleSaveAddress = async () => {
    // setBillingFormData(initialFormData);
    const newValidationErrors = {};

    // Validate mobile number (10 digits)
    if (!/^[0-9]{10}$/.test(billingFormData.mobileNo)) {
      newValidationErrors.mobileNo = "Invalid mobile number (10 digits)";
    }

    // Validate email
    // if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(billingFormData.email)) {
    //   newValidationErrors.email = "Invalid email";
    // }

    // Validate pincode (6 digits)
    if (!/^[0-9]{6}$/.test(billingFormData.pincode)) {
      newValidationErrors.pincode = "Invalid pincode (6 digits)";
    }
    if (billingFormData.gst.trim() !== "") {
      if (!gstRegex.test(billingFormData.gst)) {
        newValidationErrors.gst = "Invalid GSTIN";
      }
    }

    setValidationErrors(newValidationErrors);

    if (Object.values(newValidationErrors).some((error) => !!error)) {
      // If there are validation errors, stop the function
      return;
    }

    const params = {
      mob_user: params_id?.quote_id
        ? mob_user_2?.rfq_order?.rfq_created_by?.id || mob_user_2?.user?.id
        : mob_user?.id ||
          mob_user?.payload?.user_details?.id ||
          mob_user?.payload?.id,

      name: addCustName,
      phone_number: addCustMobileNo,
      email: addCustEmail,
      gst_number: addCustGSTIN,
      address: {
        address_type: billingFormData?.address_type,
        name: billingFormData.nameCompany,
        gst_number: billingFormData.gst,
        phone_number: billingFormData.mobileNo,
        email: billingFormData.email,
        address_line_1: billingFormData.addressI,
        address_line_2: billingFormData.addressII,
        google_map_link: billingFormData.addressII,
        city: billingFormData.city,
        state: billingFormData.state,
        pincode: billingFormData.pincode,
        address_tag: billingFormData.address_tag,
        latitude: billingFormData.lat,
        longitude: billingFormData.lng,
      },
    };
    if (editData?.id) {
      const params = {
        name: billingFormData.nameCompany,
        phone_number: billingFormData.mobileNo,
        address_line_1: billingFormData.addressI,
        address_line_2: billingFormData.addressII,
        city: billingFormData.city,
        state: billingFormData.state,
        pincode: billingFormData.pincode,
        address_type: billingFormData?.address_type,
        email: billingFormData.email,
        gst_number: billingFormData.gst,
        google_map_link: billingFormData.addressII,
        site_person: billingFormData.site_person,
        site_person_mobile: billingFormData.site_person_mobile,
        address_tag: billingFormData.address_tag,
        address_id: editData.id,
        latitude: billingFormData.lat,
        longitude: billingFormData.lng,
      };
      const response = await updateAddressApi(params);
      if (response?.data?.status === true) {
        setBillingModal(false);
        showSuccessToast(response?.data?.message);
        dispatch(getBillingAddress(response?.data?.data));
        setBillingFormData(initialFormData);

        // if (response?.data?.data?.id === billingAddressRedux?.id) {
        // }
        if (response?.data?.data?.id === deliveryAddressRedux?.id) {
          dispatch(getDeliveryAddress(response?.data?.data));
        }
      }
      // else {
      //   if (response?.error?.data?.data?.email[0]) {
      //     showErrorToast(response?.error?.data?.data?.email[0]);
      //   }
      // }
    } else {
      const response = await createNewAddressApi(params);
      if (response?.data?.status === true) {
        setBillingModal(false);
        showSuccessToast(response?.data?.message);
        dispatch(getBillingAddress(response?.data?.data));
        setBillingFormData(initialFormData);
        if (params?.mob_user === 0 || params?.mob_user === undefined) {
          const userData = {
            id: response?.data?.data?.id,
            // id: response?.data?.data?.customer,
            name: response?.data?.data?.name,
            phoneNumber: response?.data?.data?.phone_number,
            mobVendor: response?.data?.data?.customer,
          };
          dispatch(getCreateOrderUserData(userData));
          //  dispatch(getBillingAddress(response?.data?.data));
          //handleSetSelector(userData);
          getEditOrderAddressAPI({ phone_number: addCustMobileNo });
        } else {
          if (response?.data?.data?.id === deliveryAddressRedux?.id) {
            dispatch(getDeliveryAddress(response?.data?.data));
          }
        }
        addressListModal();
      }
      //  else {
      //   if (response?.error?.data?.data?.email[0]) {
      //     showErrorToast(response?.error?.data?.data?.email[0]);
      //   }
      // }
    }
  };
  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingFormData]);

  useEffect(() => {
    const handleResize = () => setIsMobileView(getIsMobileView());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleInputChange = (field, value) => {
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));
    setBillingFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    // validateForm();
  };
  const handleBack = () => {
    setBillingFormData(initialFormData);
    setBillingModal(false);
    setIsModalOpen(true);
  };
  const tagData = editData?.address_tag;
  // const isDisabledBillingAddressCheck = isDisabledBillingAddress(
  //   addressList || [],
  //   billingFormData
  // );

  const handleChangeAddress = () => {
    setShowGoogleMapsModal(true);
    setPendingAddressType("Billing");
  };

  const modalTitle = (
    <Row style={{ width: "100%", alignItems: "center" }}>
      <Col style={{ paddingTop: "6px", width: "35%" }}>
        <LeftArrowIcon style={{ cursor: "pointer" }} onClick={() => handleBack()} />
      </Col>
      <Title level={4} style={{ width: "65%", margin: 0 }}>
        Billing Address
      </Title>
    </Row>
  );

  const footerContent = (
    <Col
      className={isMobileView ? "billing-address-mobile-footer" : ""}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "28px",
        width: "100%",
      }}
    >
      <Button
        onClick={handleCancel}
        style={{
          height: "48px",
          fontWeight: 500,
          fontSize: "14px",
          maxWidth: "120px",
          width: "100%",
        }}
      >
        CANCEL
      </Button>
      <Button
        loading={isCreateLoading || isUpdateLoading}
        style={{
          height: "48px",
          fontWeight: 500,
          fontSize: "14px",
          border: "none",
          color: "white",
          backgroundColor: "#0354a3",
        }}
        disabled={!isFormValid}
        onClick={handleSaveAddress}
      >
        {editData?.name ? "SAVE & UPDATE ADDRESS" : "SAVE THIS ADDRESS"}
      </Button>
    </Col>
  );

  return (
    <>
      {isMobileView ? (
        <Drawer
          title={modalTitle}
          className="billing-address-mobile-drawer"
          wrapClassName="billing-address-mobile-drawer-wrap"
          placement="bottom"
          height="90vh"
          open={billingModal}
          onClose={handleCancel}
          closable={false}
          bodyStyle={{ padding: 0 }}
          contentWrapperStyle={{
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
            overflow: "hidden",
          }}
        >
          <div className="billing-address-drawer-body">
            <div className="billing-address-drawer-scroll">
      <Form
          name="billing_address"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          style={{
            height: "100%",
            width: "100%",
            overflow: "auto",
          }}
          autoComplete="off"
        >
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "2px 18px 18px 18px",
              gap: 12,
            }}
          >
            {editData?.id && editLocation && (
              <div className="selected-map-section">
                <div className="map-preview-container" style={{ height: "250px", width: "100%", marginBottom: "12px", borderRadius: "8px", overflow: "hidden" }}>
                  {isLoaded && (
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      center={editLocation}
                      zoom={15}
                      options={{
                        disableDefaultUI: true,
                        zoomControl: false,
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        gestureHandling: "none",
                        draggable: false,
                        scrollwheel: false,
                        disableDoubleClickZoom: true,
                      }}
                      onLoad={(mapInstance) => {
                        if (mapInstance.customMarker) {
                          mapInstance.customMarker.setMap(null);
                        }

                        const customMarkerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="56" viewBox="0 0 38 56" fill="none">
                  <path opacity="0.8" d="M18.5512 56.0038C24.5311 56.0038 29.3788 54.6143 29.3788 52.9003C29.3788 51.1863 24.5311 49.7969 18.5512 49.7969C12.5713 49.7969 7.72363 51.1863 7.72363 52.9003C7.72363 54.6143 12.5713 56.0038 18.5512 56.0038Z" fill="#00DE9D"/>
                  <path d="M18.5944 0C8.34168 0 0 8.34113 0 18.5932C0 26.9743 5.55225 34.2588 13.5705 36.4985L17.6935 52.2679C17.7999 52.6777 18.1713 52.9638 18.5944 52.9638C19.0176 52.9638 19.389 52.6777 19.4954 52.2679L23.6184 36.4985C31.6367 34.2588 37.1889 26.9743 37.1889 18.5932C37.1889 8.34113 28.8472 0 18.5944 0Z" fill="#1C1C1C"/>
                  <ellipse cx="18.6207" cy="18.483" rx="6.06897" ry="6.06898" fill="white"/>
                </svg>`;

                        const marker = new window.google.maps.Marker({
                          position: editLocation,
                          map: mapInstance,
                          title: "Selected Location",
                          icon: {
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(customMarkerSVG),
                            scaledSize: new window.google.maps.Size(18, 26),
                            anchor: new window.google.maps.Point(9, 26),
                            origin: new window.google.maps.Point(0, 0),
                          },
                          optimized: false,
                        });

                        mapInstance.customMarker = marker;
                      }}
                      onUnmount={() => {
                        if (previewMap && previewMap.customMarker) {
                          previewMap.customMarker.setMap(null);
                          previewMap.customMarker = null;
                        }
                      }}
                    />
                  )}
                </div>
              </div>
            )}
            {selectedMapAddress && !editData?.id && (
              <div className="selected-map-section">
                <div className="map-preview-container" style={{ height: "250px", width: "100%", marginBottom: "12px", borderRadius: "8px", overflow: "hidden" }}>
                  {isLoaded && (
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      center={{ lat: selectedMapAddress.lat, lng: selectedMapAddress.lng }}
                      zoom={15}
                      options={{
                        disableDefaultUI: true,
                        zoomControl: false,
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        gestureHandling: "none",
                        draggable: false,
                        scrollwheel: false,
                        disableDoubleClickZoom: true,
                      }}
                      onLoad={(mapInstance) => {
                        setPreviewMap(mapInstance);
                        if (mapInstance.customMarker) {
                          mapInstance.customMarker.setMap(null);
                        }

                        const customMarkerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="56" viewBox="0 0 38 56" fill="none">
                          <path opacity="0.8" d="M18.5512 56.0038C24.5311 56.0038 29.3788 54.6143 29.3788 52.9003C29.3788 51.1863 24.5311 49.7969 18.5512 49.7969C12.5713 49.7969 7.72363 51.1863 7.72363 52.9003C7.72363 54.6143 12.5713 56.0038 18.5512 56.0038Z" fill="#00DE9D"/>
                          <path d="M18.5944 0C8.34168 0 0 8.34113 0 18.5932C0 26.9743 5.55225 34.2588 13.5705 36.4985L17.6935 52.2679C17.7999 52.6777 18.1713 52.9638 18.5944 52.9638C19.0176 52.9638 19.389 52.6777 19.4954 52.2679L23.6184 36.4985C31.6367 34.2588 37.1889 26.9743 37.1889 18.5932C37.1889 8.34113 28.8472 0 18.5944 0Z" fill="#1C1C1C"/>
                          <ellipse cx="18.6207" cy="18.483" rx="6.06897" ry="6.06898" fill="white"/>
                        </svg>`;

                        const marker = new window.google.maps.Marker({
                          position: { lat: selectedMapAddress.lat, lng: selectedMapAddress.lng },
                          map: mapInstance,
                          title: "Selected Location",
                          icon: {
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(customMarkerSVG),
                            scaledSize: new window.google.maps.Size(18, 26),
                            anchor: new window.google.maps.Point(9, 26),
                            origin: new window.google.maps.Point(0, 0),
                          },
                          optimized: false,
                        });

                        mapInstance.customMarker = marker;
                      }}
                      onUnmount={() => {
                        if (previewMap && previewMap.customMarker) {
                          previewMap.customMarker.setMap(null);
                          previewMap.customMarker = null;
                        }
                      }}
                    />
                  )}
                </div>
                <div className="selected-address-info">
                  <div className="address-header">
                    <div className="address-icon-text">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#22C55E"/>
                      </svg>
                      <Text className="location-name">Selected Location</Text>
                    </div>
                    <Button 
                      className="change-link-button"
                      onClick={handleChangeAddress}
                      type="link"
                    >
                      CHANGE
                    </Button>
                  </div>
                  <Text className="full-address-text">{selectedMapAddress.formatted_address || selectedMapAddress.address}</Text>
                </div>
              </div>
            )}
            <Form.Item
              label={
                <Col>
                  Name / Company<Text style={{ color: "#FF0000" }}> *</Text>
                </Col>
              }
              style={{ margin: 0 }}
            >
              <Input
                style={{ height: 45 }}
                name="nameCompany"
                value={billingFormData.nameCompany}
                onChange={(e) =>
                  handleInputChange("nameCompany", e.target.value)
                }
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Business Mobile(for OTP){" "}
                    <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0 }}
                help={
                  validationErrors.mobileNo && (
                    <Col style={{ color: "red" }}>
                      Invalid mobile number (10 digits)
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.mobileNo ? "red" : "",
                    backgroundColor: validationErrors.mobileNo ? "#FFD6D6" : "",
                  }}
                  maxLength={10}
                  name="mobileNo"
                  value={billingFormData.mobileNo}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange("mobileNo", e.target.value);
                    }
                  }}
                />
              </Form.Item>
              <Form.Item
                label="GSTIN (Optional)"
                style={{ margin: 0 }}
                help={
                  validationErrors.gst && (
                    <Col
                      style={{
                        color: "red",
                      }}
                    >
                      Invalid Gst No
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.gst ? "red" : "",
                    backgroundColor: validationErrors.gst ? "#FFD6D6" : "",
                  }}
                  value={billingFormData.gst}
                  name="gst"
                  maxLength={15}
                  onChange={(e) => handleInputChange("gst", e.target.value)}
                />
              </Form.Item>
            </Col>
          </Col>
          <Divider style={{ margin: 0, borderTopWidth: "12px" }} />
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 18px 18px 18px",
              gap: 12,
            }}
          >
            <Form.Item
              label={
                <Col>
                  House no/ Building name (Address line 1)
                  <Text style={{ color: "#FF0000" }}> *</Text>
                </Col>
              }
              style={{ margin: 0 }}
            >
              <Input
                value={billingFormData.addressI}
                name="addressI"
                style={{ height: 45 }}
                onChange={(e) => handleInputChange("addressI", e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Road/ Area/ Colony or google maps link"
              style={{ margin: 0 }}
            >
              <Input
                style={{ height: 45 }}
                name="addressII"
                value={billingFormData.addressII}
                onChange={(e) => handleInputChange("addressII", e.target.value)}
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Pincode
                    <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                help={
                  validationErrors.pincode && (
                    <Col style={{ color: "red" }}>
                      Invalid pincode (6 digits)
                    </Col>
                  )
                }
                style={{ margin: 0 }}
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.pincode ? "red" : "",
                    backgroundColor: validationErrors.pincode ? "#FFD6D6" : "",
                  }}
                  maxLength={6}
                  name="pincode"
                  value={billingFormData.pincode}
                  onChange={(e) => {
                    if (/^\d{0,6}$/.test(e.target.value)) {
                      handleInputChange("pincode", e.target.value);
                    }
                  }}
                />
              </Form.Item>
              <Form.Item
                label={
                  <Col>
                    City<Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="city"
                  value={billingFormData.city}
                  onChange={(e) => handleInputChange("city", e.target.value)}
                />
              </Form.Item>
            </Col>
            <Form.Item
              label={
                <Col>
                  State<Text style={{ color: "#FF0000" }}> *</Text>
                </Col>
              }
              style={{ margin: 0 }}
            >
              <Select
                showSearch
                placeholder="--Select or Search  state--"
                onChange={(e) => handleInputChange("state", e)}
                value={billingFormData.state}
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  height: "45px",
                }}
              >
                <Option disabled value="">
                  --Select or Search state--
                </Option>
                {stateOptions.map((option, index) => (
                  <Option key={index} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={
                <Col>
                  Email
                </Col>
              }
              help={
                validationErrors.email && (
                  <Col style={{ color: "red" }}>Invalid email</Col>
                )
              }
              style={{ margin: 0 }}
            >
              <Input
                value={billingFormData.email}
                name="email"
                style={{
                  height: 45,
                  borderColor: validationErrors.email ? "red" : "",
                  backgroundColor: validationErrors.email ? "#FFD6D6" : "",
                }}
                onChange={(e) => handleInputChange("email", e.target.value)}
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={<Col>Site person(for delivery)</Col>}
                style={{ margin: 0 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="site_person"
                  value={billingFormData?.site_person}
                  onChange={(e) =>
                    handleInputChange("site_person", e.target.value)
                  }
                />
              </Form.Item>

              <Form.Item
                label={<Col>Site person mobile</Col>}
                style={{ margin: 0 }}
                help={
                  validationErrors.site_person_mobile && (
                    <Col style={{ color: "red" }}>
                      Invalid mobile number (10 digits)
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.site_person_mobile
                      ? "red"
                      : "",
                    backgroundColor: validationErrors.site_person_mobile
                      ? "#FFD6D6"
                      : "",
                  }}
                  name="site_person_mobile"
                  maxLength={10}
                  value={billingFormData?.site_person_mobile}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange("site_person_mobile", e.target.value);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Form.Item
              name="radioGroup"
              className="hidden"
              label="Select Tag"
              style={{ margin: 0 }}
            >
              <Radio.Group
                defaultValue={tagData}
                onChange={(e) =>
                  handleInputChange("address_tag", e.target.value)
                }
                name={"address_tag"}
              >
                <Radio value="Home">
                  <Tag
                    style={{
                      width: "60px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Home
                  </Tag>
                </Radio>
                <Radio value="Office">
                  <Tag
                    style={{
                      width: "70px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Office
                  </Tag>
                </Radio>

                {mob_credit_check && !showMobCreditIcon && (
                  <Radio value={"mobCredit"} className="radio-mob-credit">
                    <Tag
                      style={{
                        width: "120px",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      MOB CREDIT
                    </Tag>
                  </Radio>
                )}
              </Radio.Group>
            </Form.Item>

            <Checkbox
              value={"Billing"}
              checked={billingFormData?.address_type === "Billing"}
              onChange={(e) => handleAddressTag(e)}
              name={"address_type"}
            >
              <Text
                style={{
                  height: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                Mark as billing address
              </Text>
            </Checkbox>
          </Col>
          <UserBillingConfirmModal
            open={openBillingModal}
            handleCancel={handleCancelBillingModal}
            handleSave={handleSaveBillingModal}
          />
        </Form>
            </div>
            {footerContent}
          </div>
        </Drawer>
      ) : (
      <Modal
        title={modalTitle}
        open={billingModal}
        onCancel={handleCancel}
        closeIcon={false}
        footer={[footerContent]}
      >
        <Form
          name="billing_address"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          style={{
            height: "360px",
            width: "100%",
            overflow: "auto",
          }}
          autoComplete="off"
        >
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "2px 18px 18px 18px",
              gap: 12,
            }}
          >
            {editData?.id && editLocation && (
              <div className="selected-map-section">
                <div className="map-preview-container" style={{ height: "250px", width: "100%", marginBottom: "12px", borderRadius: "8px", overflow: "hidden" }}>
                  {isLoaded && (
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      center={editLocation}
                      zoom={15}
                      options={{
                        disableDefaultUI: true,
                        zoomControl: false,
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        gestureHandling: "none",
                        draggable: false,
                        scrollwheel: false,
                        disableDoubleClickZoom: true,
                      }}
                      onLoad={(mapInstance) => {
                        if (mapInstance.customMarker) {
                          mapInstance.customMarker.setMap(null);
                        }

                        const customMarkerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="56" viewBox="0 0 38 56" fill="none">
                  <path opacity="0.8" d="M18.5512 56.0038C24.5311 56.0038 29.3788 54.6143 29.3788 52.9003C29.3788 51.1863 24.5311 49.7969 18.5512 49.7969C12.5713 49.7969 7.72363 51.1863 7.72363 52.9003C7.72363 54.6143 12.5713 56.0038 18.5512 56.0038Z" fill="#00DE9D"/>
                  <path d="M18.5944 0C8.34168 0 0 8.34113 0 18.5932C0 26.9743 5.55225 34.2588 13.5705 36.4985L17.6935 52.2679C17.7999 52.6777 18.1713 52.9638 18.5944 52.9638C19.0176 52.9638 19.389 52.6777 19.4954 52.2679L23.6184 36.4985C31.6367 34.2588 37.1889 26.9743 37.1889 18.5932C37.1889 8.34113 28.8472 0 18.5944 0Z" fill="#1C1C1C"/>
                  <ellipse cx="18.6207" cy="18.483" rx="6.06897" ry="6.06898" fill="white"/>
                </svg>`;

                        const marker = new window.google.maps.Marker({
                          position: editLocation,
                          map: mapInstance,
                          title: "Selected Location",
                          icon: {
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(customMarkerSVG),
                            scaledSize: new window.google.maps.Size(18, 26),
                            anchor: new window.google.maps.Point(9, 26),
                            origin: new window.google.maps.Point(0, 0),
                          },
                          optimized: false,
                        });

                        mapInstance.customMarker = marker;
                      }}
                      onUnmount={() => {
                        if (previewMap && previewMap.customMarker) {
                          previewMap.customMarker.setMap(null);
                          previewMap.customMarker = null;
                        }
                      }}
                    />
                  )}
                </div>
              </div>
            )}
            {selectedMapAddress && !editData?.id && (
              <div className="selected-map-section">
                <div className="map-preview-container" style={{ height: "250px", width: "100%", marginBottom: "12px", borderRadius: "8px", overflow: "hidden" }}>
                  {isLoaded && (
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      center={{ lat: selectedMapAddress.lat, lng: selectedMapAddress.lng }}
                      zoom={15}
                      options={{
                        disableDefaultUI: true,
                        zoomControl: false,
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        gestureHandling: "none",
                        draggable: false,
                        scrollwheel: false,
                        disableDoubleClickZoom: true,
                      }}
                      onLoad={(mapInstance) => {
                        setPreviewMap(mapInstance);
                        if (mapInstance.customMarker) {
                          mapInstance.customMarker.setMap(null);
                        }

                        const customMarkerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="56" viewBox="0 0 38 56" fill="none">
                          <path opacity="0.8" d="M18.5512 56.0038C24.5311 56.0038 29.3788 54.6143 29.3788 52.9003C29.3788 51.1863 24.5311 49.7969 18.5512 49.7969C12.5713 49.7969 7.72363 51.1863 7.72363 52.9003C7.72363 54.6143 12.5713 56.0038 18.5512 56.0038Z" fill="#00DE9D"/>
                          <path d="M18.5944 0C8.34168 0 0 8.34113 0 18.5932C0 26.9743 5.55225 34.2588 13.5705 36.4985L17.6935 52.2679C17.7999 52.6777 18.1713 52.9638 18.5944 52.9638C19.0176 52.9638 19.389 52.6777 19.4954 52.2679L23.6184 36.4985C31.6367 34.2588 37.1889 26.9743 37.1889 18.5932C37.1889 8.34113 28.8472 0 18.5944 0Z" fill="#1C1C1C"/>
                          <ellipse cx="18.6207" cy="18.483" rx="6.06897" ry="6.06898" fill="white"/>
                        </svg>`;

                        const marker = new window.google.maps.Marker({
                          position: { lat: selectedMapAddress.lat, lng: selectedMapAddress.lng },
                          map: mapInstance,
                          title: "Selected Location",
                          icon: {
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(customMarkerSVG),
                            scaledSize: new window.google.maps.Size(18, 26),
                            anchor: new window.google.maps.Point(9, 26),
                            origin: new window.google.maps.Point(0, 0),
                          },
                          optimized: false,
                        });

                        mapInstance.customMarker = marker;
                      }}
                      onUnmount={() => {
                        if (previewMap && previewMap.customMarker) {
                          previewMap.customMarker.setMap(null);
                          previewMap.customMarker = null;
                        }
                      }}
                    />
                  )}
                </div>
                <div className="selected-address-info">
                  <div className="address-header">
                    <div className="address-icon-text">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#22C55E"/>
                      </svg>
                      <Text className="location-name">Selected Location</Text>
                    </div>
                    <Button 
                      className="change-link-button"
                      onClick={handleChangeAddress}
                      type="link"
                    >
                      CHANGE
                    </Button>
                  </div>
                  <Text className="full-address-text">{selectedMapAddress.formatted_address || selectedMapAddress.address}</Text>
                </div>
              </div>
            )}
            <Form.Item
              label={
                <Col>
                  Name / Company<Text style={{ color: "#FF0000" }}> *</Text>
                </Col>
              }
              style={{ margin: 0 }}
            >
              <Input
                style={{ height: 45 }}
                name="nameCompany"
                value={billingFormData.nameCompany}
                onChange={(e) =>
                  handleInputChange("nameCompany", e.target.value)
                }
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Business Mobile(for OTP){" "}
                    <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0 }}
                help={
                  validationErrors.mobileNo && (
                    <Col style={{ color: "red" }}>
                      Invalid mobile number (10 digits)
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.mobileNo ? "red" : "",
                    backgroundColor: validationErrors.mobileNo ? "#FFD6D6" : "",
                  }}
                  maxLength={10}
                  // onKeyDown={(e) => {
                  //   if (
                  //     e.ctrlKey &&
                  //     e.key === "c" &&
                  //     e.ctrlKey &&
                  //     e.key === "v" &&
                  //     e.ctrlKey &&
                  //     e.key === "x" &&
                  //     (e.key < "0" || e.key > "9") &&
                  //     e.key !== "Backspace" &&
                  //     e.key !== "ArrowLeft" &&
                  //     e.key !== "ArrowRight" &&
                  //     e.key !== "Tab"
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                  name="mobileNo"
                  value={billingFormData.mobileNo}
                  // onChange={(e) =>
                  //   handleInputChange("mobileNo", e.target.value)
                  // }
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange("mobileNo", e.target.value);
                    }
                  }}
                />
              </Form.Item>
              <Form.Item
                label="GSTIN (Optional)"
                style={{ margin: 0 }}
                help={
                  validationErrors.gst && (
                    <Col
                      style={{
                        color: "red",
                      }}
                    >
                      Invalid Gst No
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.gst ? "red" : "",
                    backgroundColor: validationErrors.gst ? "#FFD6D6" : "",
                  }}
                  value={billingFormData.gst}
                  name="gst"
                  maxLength={15}
                  onChange={(e) => handleInputChange("gst", e.target.value)}
                />
              </Form.Item>
            </Col>
          </Col>
          <Divider style={{ margin: 0, borderTopWidth: "12px" }} />
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 18px 18px 18px",
              gap: 12,
            }}
          >
            <Form.Item
              label={
                <Col>
                  House no/ Building name (Address line 1)
                  <Text style={{ color: "#FF0000" }}> *</Text>
                </Col>
              }
              style={{ margin: 0 }}
            >
              <Input
                value={billingFormData.addressI}
                name="addressI"
                style={{ height: 45 }}
                onChange={(e) => handleInputChange("addressI", e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Road/ Area/ Colony or google maps link"
              style={{ margin: 0 }}
            >
              <Input
                style={{ height: 45 }}
                name="addressII"
                value={billingFormData.addressII}
                onChange={(e) => handleInputChange("addressII", e.target.value)}
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Pincode
                    <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                help={
                  validationErrors.pincode && (
                    <Col style={{ color: "red" }}>
                      Invalid pincode (6 digits)
                    </Col>
                  )
                }
                style={{ margin: 0 }}
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.pincode ? "red" : "",
                    backgroundColor: validationErrors.pincode ? "#FFD6D6" : "",
                  }}
                  maxLength={6}
                  // onKeyDown={(e) => {
                  //   if (
                  //     e.ctrlKey &&
                  //     e.key === "c" &&
                  //     e.ctrlKey &&
                  //     e.key === "v" &&
                  //     e.ctrlKey &&
                  //     e.key === "x" &&
                  //     (e.key < "0" || e.key > "9") &&
                  //     e.key !== "Backspace" &&
                  //     e.key !== "ArrowLeft" &&
                  //     e.key !== "ArrowRight" &&
                  //     e.key !== "Tab"
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                  name="pincode"
                  value={billingFormData.pincode}
                  // onChange={(e) => handleInputChange("pincode", e.target.value)}
                  onChange={(e) => {
                    if (/^\d{0,6}$/.test(e.target.value)) {
                      handleInputChange("pincode", e.target.value);
                    }
                  }}
                />
              </Form.Item>
              <Form.Item
                label={
                  <Col>
                    City<Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="city"
                  value={billingFormData.city}
                  onChange={(e) => handleInputChange("city", e.target.value)}
                />
              </Form.Item>
            </Col>
            <Form.Item
              label={
                <Col>
                  State<Text style={{ color: "#FF0000" }}> *</Text>
                </Col>
              }
              style={{ margin: 0 }}
            >
              {/* <Select
                placeholder="--Select state--"
                onChange={(e) => handleInputChange("state", e)}
                value={billingFormData.state}
              >
                <Option disabled value="">
                  --Select state--
                </Option>
                <Option value="Karnataka">Karnataka</Option>
                <Option value="Tamil Nadu">Tamil Nadu</Option>
              </Select> */}
              <Select
                showSearch
                placeholder="--Select or Search  state--"
                onChange={(e) => handleInputChange("state", e)}
                value={billingFormData.state}
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  height: "45px",
                }}
              >
                <Option disabled value="">
                  --Select or Search state--
                </Option>
                {stateOptions.map((option, index) => (
                  <Option key={index} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={
                <Col>
                  Email
                  {/* <Text style={{ color: "#FF0000" }}> *</Text> */}
                </Col>
              }
              help={
                validationErrors.email && (
                  <Col style={{ color: "red" }}>Invalid email</Col>
                )
              }
              style={{ margin: 0 }}
            >
              <Input
                value={billingFormData.email}
                name="email"
                style={{
                  height: 45,
                  borderColor: validationErrors.email ? "red" : "",
                  backgroundColor: validationErrors.email ? "#FFD6D6" : "",
                }}
                onChange={(e) => handleInputChange("email", e.target.value)}
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={<Col>Site person(for delivery)</Col>}
                style={{ margin: 0 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="site_person"
                  value={billingFormData?.site_person}
                  onChange={(e) =>
                    handleInputChange("site_person", e.target.value)
                  }
                />
              </Form.Item>

              <Form.Item
                label={<Col>Site person mobile</Col>}
                style={{ margin: 0 }}
                help={
                  validationErrors.site_person_mobile && (
                    <Col style={{ color: "red" }}>
                      Invalid mobile number (10 digits)
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.site_person_mobile
                      ? "red"
                      : "",
                    backgroundColor: validationErrors.site_person_mobile
                      ? "#FFD6D6"
                      : "",
                  }}
                  name="site_person_mobile"
                  maxLength={10}
                  // onKeyDown={(e) => {
                  //   if (
                  //     e.ctrlKey &&
                  //     e.key === "c" &&
                  //     e.ctrlKey &&
                  //     e.key === "v" &&
                  //     e.ctrlKey &&
                  //     e.key === "x" &&
                  //     (e.key < "0" || e.key > "9") &&
                  //     e.key !== "Backspace" &&
                  //     e.key !== "ArrowLeft" &&
                  //     e.key !== "ArrowRight" &&
                  //     e.key !== "Tab"
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                  value={billingFormData?.site_person_mobile}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange("site_person_mobile", e.target.value);
                    }
                  }}
                  // onChange={(e) =>
                  //   handleInputChange("mobileNo", e.target.value)
                  // }
                />
              </Form.Item>
            </Col>
            <Form.Item
              name="radioGroup"
              className="hidden"
              label="Select Tag"
              style={{ margin: 0 }}
            >
              <Radio.Group
                defaultValue={tagData}
                onChange={(e) =>
                  handleInputChange("address_tag", e.target.value)
                }
                // onChange={(e) => handleAddressTag(e)}
                name={"address_tag"}
              >
                <Radio value="Home">
                  <Tag
                    style={{
                      width: "60px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Home
                  </Tag>
                </Radio>
                <Radio value="Office">
                  <Tag
                    style={{
                      width: "70px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Office
                  </Tag>
                </Radio>

                {mob_credit_check && !showMobCreditIcon && (
                  <Radio value={"mobCredit"} className="radio-mob-credit">
                    {/* <MobCreditWhiteIcon /> */}
                    <Tag
                      style={{
                        width: "120px",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      MOB CREDIT
                    </Tag>
                  </Radio>
                )}
              </Radio.Group>
            </Form.Item>

            <Checkbox
              value={"Billing"}
              // disabled={
              //   !gstRegex?.test(billingFormData?.gst)
              //   // billingFormData?.address_type === "Billing"
              //   //   ? true || !gstRegex?.test(billingFormData?.gst)
              //   //   : isDisabledBillingAddressCheck
              //   //   ||
              //   //     !gstRegex?.test(billingFormData?.gst)
              // }
              checked={billingFormData?.address_type === "Billing"}
              onChange={(e) => handleAddressTag(e)}
              name={"address_type"}
            >
              <Text
                style={{
                  // width: "140px",
                  height: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                Mark as billing address
              </Text>
            </Checkbox>
            {/* {!gstRegex.test(billingFormData?.gst) && (
              <Text
                style={{
                  display: "block",
                  marginTop: "0px",
                  color: "#c13615",
                  fontSize: "14px",
                  fontWeight: "normal",
                }}
              >
                Please add GSTIN to include the ‘Billing Address’ tag
              </Text>
            )} */}
          </Col>
          <UserBillingConfirmModal
            open={openBillingModal}
            handleCancel={handleCancelBillingModal}
            handleSave={handleSaveBillingModal}
          />
        </Form>
      </Modal>
      )}
    </>
  );
};

export default BillingAddress;
